import {Room} from '../Room';
import {NotificationBase} from './NotificationBase';

export class PrivateMessageNotification extends NotificationBase {

	public isPrivate: boolean = true;
	public rid: string = '';

	public constructor(obj?: Record<string, unknown>) {
		super();
		Object.assign(this, obj);
	}

	set(room: Room) {
		this.rid = <string> room.uuid;
	}
}
